import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const TooltipBackground = (props: SvgIconProps) => {
  return (
    <SvgIcon width={169} height={149} viewBox="0 0 169 149" fill="none" {...props}>
      <path
        fill="white"
        d="M65 36.5H25C20.3056 36.5 16.5 40.3056 16.5 45V120C16.5 124.694 20.3056 128.5 25 128.5H144C148.694 128.5 152.5 124.694 152.5 120V45C152.5 40.3056 148.694 36.5 144 36.5H105C100.858 36.5 97.5 33.1421 97.5 29V21C97.5 16.3056 93.6944 12.5 89 12.5H81C76.3056 12.5 72.5 16.3056 72.5 21V29C72.5 33.1421 69.1421 36.5 65 36.5Z"
        stroke="currentColor"/>
    </SvgIcon>
  );
};


